var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegrita({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23612 11.7572C7.60537 11.7572 9.07462 10.5343 9.07462 8.58128C9.07462 7.11203 7.96762 6.01291 6.46012 5.89703V5.83516C7.03743 5.74824 7.56467 5.45785 7.94672 5.01639C8.32877 4.57493 8.54046 4.01147 8.54362 3.42766C8.54362 1.72891 7.23637 0.660156 5.15287 0.660156H0.323242V11.7572H5.23612ZM2.64637 2.39041H4.55437C5.63774 2.39041 6.26099 2.89778 6.26099 3.78991C6.26099 4.72816 5.55337 5.27491 4.31474 5.27491H2.64637V2.38928V2.39041ZM2.64637 10.0269V6.80491H4.59262C5.96174 6.80491 6.70762 7.35841 6.70762 8.39678C6.70762 9.45766 5.98424 10.0269 4.64662 10.0269H2.64524H2.64637Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegrita);
export default __webpack_public_path__ + "static/media/Negrita.0199d363835edb07bce0658bf6de0a09.svg";
export { ForwardRef as ReactComponent };